// Wave 3.61 — Shared ledger row classification for Diamonds / Color Stones / Pearls.
//
// This mirrors the authoritative Python helper in
// ``backend/core/utils.py::classify_ledger_entry`` so the packet ledger
// tables never drift out of sync with the backend summary math. Any new
// ledger ``type`` introduced by future waves MUST be added here AND in the
// backend at the same time.

export const LEDGER_RECEIPT_TYPES = new Set([
  'receipt', // canonical vendor / return-from-goldsmith credit
  'transfer_in', // inbound leg of a packet-to-packet transfer
]);

export const LEDGER_ISSUE_TYPES = new Set([
  'issue', // canonical goldsmith / sale / purchase-return / return-to-vendor debit
  'transfer_out', // outbound leg of a packet-to-packet transfer
  'convert_to_stock_out', // on-approval → purchased conversion (source emptied)
  'issue_to_vendor', // remainder-on-conversion / on-approval return-to-vendor
]);

export function isReceiptLedgerType(type) {
  return LEDGER_RECEIPT_TYPES.has(type);
}

export function isIssueLedgerType(type) {
  return LEDGER_ISSUE_TYPES.has(type);
}
